<script>
import VClamp from 'vue-clamp';
export default {
    name: 'CpSocialFeedVideoPost',
    directives: {
        margin: require('../../directives/margins').margin,
        marginBottom: require('../../directives/margins').marginBottom,
        marginTop: require('../../directives/margins').marginTop,
    },
    components: {
        CpBox: require('../../box').default,
        CpBoxContent: require('../../box-content').default,
        CpGrid: require('../../grid').default,
        CpGridItem: require('../../grid-item').default,
        VClamp,
        SidebarMenuTvIcon: require('../icons/tv').default,
        CpBaseSvgIcon: require('../../base-svg-icon').default,
        CpSocialShareDialog: require('../../dialogs/social-share').default,
        //LikeActionButton: require('../actions/like-action-button').default,
        CpButton: require('../../button').default,
        LikeIcon: require('../icons/like').default,
    },
    props: {
        crowdpacId: { type: Number, default: null },
        videoUrl: { type: String, default: '' },
        crowdpacName: { type: String, default: '' },
        crowdpacSlug: { type: String, default: '' },
        description: { type: String, default: '' },
        candidateImg: { type: Object, default: {} },
        candidateLname: { type: String, default: '' },
        candidateFname: { type: String, default: '' },
    },
    computed: {
        descriptionText() {
            //remove html tags so that vue clamp works properly
            return this.description.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ');
        },
    },
    //For Button Like hardcode
    methods: {
        onClick() {
            this.liked = !this.liked;
        },
    },
    data() {
        return {
            liked: false,
            appUrl: process.env.MIX_APP_URL,
        };
    },
};
</script>

<template>
    <div class="social-feed-post-wrapper">
        <div class="social-feed-post-profile-wrapper">
            <img v-if="$root.imgAdjustedWithVersion(candidateImg)" :src="$root.croppedImgWithVersion(candidateImg, 60, 60)" class="profile-img" />
            <img
                v-else-if="$root.imgNotAdjustedWithVersion(candidateImg)"
                :src="`https://res.cloudinary.com/crowdpac/image/upload/v${candidateImg.settings.version}/${candidateImg.id}`"
                class="profile-img"
            />
            <span v-else class="profile-img social-feed-default-img profile-video-default">
                <cp-base-svg-icon
                    :width="$root.isMobile ? 36 : 30"
                    :height="$root.isMobile ? 36 : 30"
                    :viewBox="'0 0 32 24'"
                    :icon-color="'none'"
                    :stroke-color="'currentColor'"
                    style="position: relative; top: -3px"
                >
                    <sidebar-menu-tv-icon />
                </cp-base-svg-icon>
            </span>
            <div class="mini-recipient">
                <span class="profile-name mini-recipient__title" v-if="candidateFname && candidateLname">
                    <a :href="`${appUrl}/campaigns/${crowdpacId}`">{{ candidateFname }} {{ candidateLname }}</a>
                </span>
                <span class="mini-recipient__subtitle">Candidate Video</span>
            </div>
        </div>
        <h3 class="social-feed-post-title">
            <v-clamp :max-lines="1">{{ crowdpacName }}</v-clamp>
        </h3>
        <video class="candidate-video-player" controls preload="metadata">
            <source :src="`${videoUrl}#t=0.1`" type="video/mp4" />
        </video>
        <a
            v-if="!!crowdpacId && !!crowdpacSlug"
            :href="`${appUrl}/campaigns/${crowdpacId}/${crowdpacSlug}?ref_code=social-feed-tv`"
            class="social-feed-post-link"
            >View Campaign</a
        >
        <a v-else :href="`${appUrl}/campaigns/${crowdpacId}`" class="social-feed-post-link">View Campaign</a>

        <!-- Remove interaction actions -->
        <!-- I comment this code because in the future it is possible to add again the interactions -->
        <!-- <div class="social-feed-post-actions">
            <div class="post-action-button like">
                // Hardcoded Button Like
                <cp-button
                    darkgray-outline
                    noborder
                    bold
                    @click.prevent="onClick"
                    :disabled="false"
                    class="button--darkgray-outline"
                    :class="{ liked: this.liked }"
                >
                    <cp-base-svg-icon :width="26" :height="26" viewBox="0 0 32 40" :icon-color="'currentColor'" :stroke-color="'none'">
                        <like-icon />
                    </cp-base-svg-icon>
                    <span class="action-button-text">Like</span>
                </cp-button>
                // Button Like
            </div>
            <div class="post-action-button share">
                <cp-social-share-dialog
                    class="feed"
                    share-category="CrowdpacTv"
                    :type="'videos'"
                    share-button-class="button--noborder"
                    :url="`${appUrl}/feed#tv`"
                    :title="`Watch ${candidateFname} ${candidateLname} on CrowdBlue, the Social Network For Politics`"
                    :description="`I found a video of ${candidateFname} ${candidateLname} on CrowdBlue, the Social Network for Politics. Wanted to share with you! ${appUrl}/feed#tv`"
                    quote
                    hashtags="crowdBlue,politics,political crowdfunding"
                    twitter-user="crowdblue"
                ></cp-social-share-dialog>
            </div>
        </div> -->
        <div class="description-wrapper">
            <v-clamp autoresize :max-lines="2">{{ descriptionText }}</v-clamp>
        </div>
    </div>
</template>
<style>
.candidate-video-player {
    max-width: 100%;
}
video {
    max-height: 500px;
}
.description-wrapper,
.social-feed-post-link {
    font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
}
.button--darkgray-outline {
    transition: color 0.2s ease;
}
.liked {
    color: var(--highlight);
}
</style>
